import Vue from 'vue'
import App from './App'
import router from './router'
import Router from 'vue-router'

import 'babel-polyfill'
require('es6-promise').polyfill()

import store from './store/store'
import axios from 'axios'
import ElementUI from 'element-ui'
import './pages/news/vue-waterfall-easy/script/vueWaterfallEasy.js'
import 'element-ui/lib/theme-chalk/index.css'
// import 'swiper/dist/css/swiper.css'

import animated from 'animate.css' // npm install animate.css --save安装，再引入



Vue.use(animated)

// 引入tabs组件
import tabs from './components/p-tabs'
// 全局注册p-tabs组件
Vue.use(tabs);

// 基于photoswipe的vue图片预览插件
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
// 全局注册photoswipe组件
Vue.use(preview)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.prototype.$axios = axios

store.state.baseURL = axios.defaults.baseURL
Vue.use(ElementUI)

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App, vueWaterfallEasy },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js